/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginatedDto } from '../models/paginated-dto';
import { userControllerCreate } from '../fn/user/user-controller-create';
import { UserControllerCreate$Params } from '../fn/user/user-controller-create';
import { userControllerDelete } from '../fn/user/user-controller-delete';
import { UserControllerDelete$Params } from '../fn/user/user-controller-delete';
import { userControllerFindAll } from '../fn/user/user-controller-find-all';
import { UserControllerFindAll$Params } from '../fn/user/user-controller-find-all';
import { userControllerFindOne } from '../fn/user/user-controller-find-one';
import { UserControllerFindOne$Params } from '../fn/user/user-controller-find-one';
import { userControllerGetMultipleUserEmails } from '../fn/user/user-controller-get-multiple-user-emails';
import { UserControllerGetMultipleUserEmails$Params } from '../fn/user/user-controller-get-multiple-user-emails';
import { userControllerRestore } from '../fn/user/user-controller-restore';
import { UserControllerRestore$Params } from '../fn/user/user-controller-restore';
import { userControllerUpdate } from '../fn/user/user-controller-update';
import { UserControllerUpdate$Params } from '../fn/user/user-controller-update';
import { UserDto } from '../models/user-dto';
import { UserListItemDto } from '../models/user-list-item-dto';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerFindAll()` */
  static readonly UserControllerFindAllPath = '/api/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindAll$Response(params: UserControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<UserListItemDto>;
}>> {
    const obs = userControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindAll(params: UserControllerFindAll$Params, context?: HttpContext): Observable<PaginatedDto & {
'items'?: Array<UserListItemDto>;
}> {
    const resp = this.userControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedDto & {
'items'?: Array<UserListItemDto>;
}>): PaginatedDto & {
'items'?: Array<UserListItemDto>;
} => r.body)
    );
  }

  /** Path part for operation `userControllerCreate()` */
  static readonly UserControllerCreatePath = '/api/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate$Response(params: UserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate(params: UserControllerCreate$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdate()` */
  static readonly UserControllerUpdatePath = '/api/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate$Response(params: UserControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate(params: UserControllerUpdate$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerGetMultipleUserEmails()` */
  static readonly UserControllerGetMultipleUserEmailsPath = '/api/user/user-emails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetMultipleUserEmails()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMultipleUserEmails$Response(params: UserControllerGetMultipleUserEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    const obs = userControllerGetMultipleUserEmails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetMultipleUserEmails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMultipleUserEmails(params: UserControllerGetMultipleUserEmails$Params, context?: HttpContext): Observable<Array<UserDto>> {
    const resp = this.userControllerGetMultipleUserEmails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `userControllerFindOne()` */
  static readonly UserControllerFindOnePath = '/api/user/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindOne$Response(params: UserControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindOne(params: UserControllerFindOne$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerDelete()` */
  static readonly UserControllerDeletePath = '/api/user/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDelete$Response(params: UserControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = userControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDelete(params: UserControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.userControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userControllerRestore()` */
  static readonly UserControllerRestorePath = '/api/user/restore/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerRestore$Response(params: UserControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = userControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerRestore(params: UserControllerRestore$Params, context?: HttpContext): Observable<void> {
    const resp = this.userControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
